export const environment = {
  production: true,
  apiHost: 'https://hsbooster.eu/',
  apiUrl: 'https://34.242.229.191:5000',
};
